export default __webpack_public_path__ + "static/media/ic-arrow-left.c79fe89c.svg";